import "./ABCDScoreTooltip.scss";
import { ABCDScoreObject, getABCDScore } from "./ABCDUtils";
import { MdClose } from "react-icons/md";
import * as R from "ramda";

interface ABCDScoreTooltipProps {
  onHide;
  score: ABCDScoreObject;
}

export const ABCDScoreTooltip = ({ onHide, score }: ABCDScoreTooltipProps): JSX.Element => {
  const features = score.annotations_evaluation.evaluated_features;
  const { presentFeatures, totalFeatures } = getABCDScore(score);
  return (
    <div className="abcdScoreTooltip">
      <div className="header">
        <div className="label">
          ABCD Score {presentFeatures}/{totalFeatures}
        </div>
        <div className="closeIcon" onClick={() => onHide()}>
          <MdClose />
        </div>
      </div>
      <div className="scoreContainer">
        {R.map(
          feature => (
            <div className="feature">
              <div className={feature.detected ? "green" : "red"}></div>{" "}
              <div className="label">{feature.name}</div>
            </div>
          ),
          R.filter(feature => !feature.disabled, features) as Record<string, any>[]
        )}
      </div>
    </div>
  );
};
